import "./_shorts.scss"
import {useFetch} from "../../utils/hooks/useFetch";
import {motion} from 'framer-motion';

function Shorts() {
    const [data] = useFetch("/JSON/shorts.json");

    return (
        <motion.div
            initial={{ translateY: "100vh" }}
            animate={{ translateY: 0, transition: { duration: 0.3 } }}
            exit={{ translateY: "-100vh", transition: { duration: 0.3 } }}
        >
            <div className="short_title">
                <h2>Court-métrages</h2>
                <h3>Sélection de fictions</h3>
            </div>
            
            <div className="shorts-wrapper">
                {data && data.map((obj, index) => (
                    <div className="short-card" key={index}>
                        <div className="short-img-container">
                            <img src={obj.cover} alt={obj.alt} />
                        </div>
                        
                        <div className="short-infos">
                            <div className="short-header">
                                <h4>{obj.title} <span className="short-year">({obj.year})</span></h4>
                                <p className="short-director">Réalisé par : {obj.director}</p>
                            </div>

                            {obj.description && (
                                <div className="short-infos-description">
                                    <h5>Synopsis</h5>
                                    <p>{obj.description}</p>
                                </div>
                            )}

                            {obj.link && (
                                <a href={obj.link} target="_blank" rel="noreferrer" className="short-btn">
                                    VOIR LE FILM <span>▸</span>
                                </a>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </motion.div>
    );
}
export default Shorts;

